import { defineComponent as _defineComponent } from 'vue'
import {
  unref,
} from "vue";

import IconTextButton from "@/components/buttons/IconTextButton.vue";

import TimeSpanDialog from "@/components/base/TimeSpanDialog.vue";

import DeadlineDialog from "@/components/base/DeadlineDialog.vue";

import {
  DateFormats,
} from "@/scripts/Common/DateFormats";

import {
  getAccessRights,
} from "@/authorization";

import {
  reportPolicies,
} from "@/authorization/policies/reportPolicies";

import {
  useI18n,
} from "@/composables";

import {
  ReportData,
  Reports,
} from "@/components/reports/scripts/types";

import {
  downloadCsvReport,
  fetchReport,
} from "@/components/reports/scripts";


export default /*#__PURE__*/_defineComponent({
  __name: 'Report',
  emits: [
  'onFetchError'
],
  setup(__props, { emit: emits }) {

const {
  t,
  locale,
} = useI18n();

const {
  hasDownloadRights
} = getAccessRights(reportPolicies);

const hasNoDownloadRights = !hasDownloadRights;



const onHandleFetchError = ({error}: {
  error: any
}) => {
  emits('onFetchError', {error})
};

const startDownload = (fileName: string, content: string | undefined, startDate: string, endDate?: string) => {
  const data: ReportData = {
    fileName,
    dateFormat: DateFormats.YEAR_MONTH_DAY,
    startDate,
    endDate,
    content
  };

  downloadCsvReport(data);
}

const downloadChargeReport = async (startDate: string, endDate: string) => {
  const queries = {startDate, endDate};
  const {response, error} = await fetchReport(Reports.chargeReport, unref(locale), queries);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  startDownload(t("charge_report_file_name").toString(), response, startDate, endDate);
}

const downloadChargeLimitReport = async (startDate: string, endDate: string) => {
  const queries = {startDate, endDate};
  const {response, error} = await fetchReport(Reports.chargeLimitReport, unref(locale), queries);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  startDownload(t("charge_limit_report_file_name").toString(), response, startDate, endDate);
}

const downloadCardBalanceReport = async (deadline: string) => {
  const routeParams = {deadline};
  const {response, error} = await fetchReport(Reports.cardBalanceReport, unref(locale), undefined, routeParams);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  startDownload(t("card_balance_report_file_name").toString(), response, deadline);
}

const downloadTrxCountErrorReport = async (startDate: string, endDate: string) => {
  const queries = {startDate, endDate};
  const {response, error} = await fetchReport(Reports.trxErrorReport, unref(locale), queries);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  startDownload(t("trx_count_error_report_file_name").toString(), response, startDate, endDate);
}

const downloadSalesReport = async (startDate: string, endDate: string) => {
  const queries = {startDate, endDate};
  const {response, error} = await fetchReport(Reports.salesReport, unref(locale), queries);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  startDownload(t("customer_sales_report_file_name").toString(), response, startDate, endDate);
}

return { __sfc: true,t, locale, hasDownloadRights, hasNoDownloadRights, emits, onHandleFetchError, startDownload, downloadChargeReport, downloadChargeLimitReport, downloadCardBalanceReport, downloadTrxCountErrorReport, downloadSalesReport, IconTextButton, TimeSpanDialog, DeadlineDialog }
}

})